import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { type RootState } from 'store';

/**
 * Format json values into form data for fastapi
 * @param json json data to be formatted
 * @returns FormData instance containing the values from json
 */
export const jsonToFormData = (
    json: Record<string, string[] | File[] | string | number | boolean | File | undefined | null>,
) => {
    const formattedData = new FormData();
    Object.entries(json).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => formattedData.append(key, item));
        } else if (value != null) {
            if (typeof value === 'object') {
                formattedData.append(key, value);
            } else {
                formattedData.append(key, String(value));
            }
        }
    });
    return formattedData;
};

/**
 * Format json values into query params for fastapi
 * @param json json data to be formatted
 * @returns URLSearchParams instance containing the values from json
 */
export const jsonToUrlSearchParams = (
    json: Record<string, string[] | string | number | boolean | undefined | null>,
) => {
    const formattedData = new URLSearchParams();
    Object.entries(json).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => formattedData.append(key, item));
        } else if (value != null) {
            formattedData.append(key, String(value));
        }
    });
    return formattedData;
};

export const getBaseQuery = (url: string) =>
    fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}${url}`,
        paramsSerializer: (params) => jsonToUrlSearchParams(params).toString(),
        prepareHeaders: (headers, { getState }) => {
            headers.set('authorization', `Bearer ${(getState() as RootState).auth.accessToken}`);
            return headers;
        },
    });
